var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecursoMasherramientas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 862 96",
    style: {
      enableBackground: "new 0 0 862 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;enable-background:new    ;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#707070;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1449",
    transform: "translate(-522.729 -5822.945)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.9,5898.9l-0.1-40.3l-20,33.6h-3.6l-20-33.3v40.1h-7.6v-55.3h6.5l23.1,38.9l22.8-38.9h6.5l0.1,55.3H582.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.3,5885.1h-29.4l-6.1,13.8h-8.1l25-55.3h7.8l25.1,55.3h-8.3L642.3,5885.1z M639.5,5878.8l-11.9-27.1l-11.9,27.1H639.5 z M628.8,5839.1h-7.1l10.7-10.3h9.6L628.8,5839.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.8,5892.6l2.9-6.2c4.1,3.7,11.1,6.4,18.2,6.4c9.6,0,13.7-3.7,13.7-8.5c0-13.5-33.5-5-33.5-25.5 c0-8.5,6.6-15.8,21.2-15.8c6.5,0,13.2,1.7,17.8,4.9l-2.6,6.3c-4.8-3.1-10.3-4.5-15.2-4.5c-9.4,0-13.4,4-13.4,8.8 c0,13.5,33.5,5.1,33.5,25.4c0,8.5-6.8,15.7-21.4,15.7C672.5,5899.6,664.2,5896.7,659.8,5892.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.7,5843.6v55.3h-7.9v-24.6h-31.8v24.6h-7.9v-55.3h7.9v23.8h31.8v-23.8H782.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.4,5892.1v6.9h-40.1v-55.3h39v6.9h-31.1v17h27.7v6.7h-27.7v17.9H839.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.2,5898.9l-11.9-17c-1.1,0.1-2.3,0.2-3.5,0.2h-13.7v16.8h-7.9v-55.3h21.6c14.4,0,23.1,7.3,23.1,19.3 c0,8.5-4.4,14.7-12.2,17.5l13.1,18.6H889.2z M889,5862.9c0-7.9-5.3-12.4-15.4-12.4h-13.4v24.9h13.4 C883.7,5875.4,889,5870.8,889,5862.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.7,5898.9l-11.9-17c-1.1,0.1-2.3,0.2-3.5,0.2h-13.7v16.8h-7.9v-55.3h21.6c14.4,0,23.1,7.3,23.1,19.3 c0,8.5-4.4,14.7-12.2,17.5l13.1,18.6H946.7z M946.4,5862.9c0-7.9-5.3-12.4-15.4-12.4h-13.4v24.9H931 C941.1,5875.4,946.4,5870.8,946.4,5862.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.3,5885.1H973l-6.1,13.8h-8.1l25-55.3h7.8l25.1,55.3h-8.3L1002.3,5885.1z M999.6,5878.8l-11.9-27.1l-11.9,27.1H999.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.2,5898.9l-0.1-40.3l-20,33.6h-3.6l-20-33.3v40.1h-7.6v-55.3h6.5l23.1,38.9l22.8-38.9h6.5l0.1,55.3H1076.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.4,5843.6h7.9v55.3h-7.9V5843.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165,5892.1v6.9h-40.1v-55.3h39v6.9h-31.1v17h27.7v6.7h-27.7v17.9H1165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.4,5843.6v55.3h-6.5l-33.2-41.2v41.2h-7.9v-55.3h6.5l33.2,41.2v-41.2H1225.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.9,5850.5h-19v-6.9h45.7v6.9h-19v48.4h-7.8V5850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.8,5885.1h-29.4l-6.1,13.8h-8.1l25-55.3h7.8l25.1,55.3h-8.3L1320.8,5885.1z M1318,5878.8l-11.9-27.1l-11.9,27.1H1318 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.3,5892.6l2.9-6.2c4.1,3.7,11.1,6.4,18.2,6.4c9.6,0,13.7-3.7,13.7-8.5c0-13.5-33.5-5-33.5-25.5 c0-8.5,6.6-15.8,21.2-15.8c6.5,0,13.2,1.7,17.8,4.9l-2.6,6.3c-4.8-3.1-10.3-4.5-15.2-4.5c-9.4,0-13.4,4-13.4,8.8 c0,13.5,33.5,5.1,33.5,25.4c0,8.5-6.8,15.7-21.4,15.7C1351.1,5899.6,1342.8,5896.7,1338.3,5892.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M709.1,5890.1l-0.1-27l-13.4,22.5h-2.4l-13.4-22.4v26.9h-5.1V5853h4.3l15.5,26.1l15.3-26.1h4.3l0.1,37.1 H709.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M749,5880.8h-19.7l-4.1,9.3h-5.5l16.8-37.1h5.2l16.9,37.1h-5.6L749,5880.8z M747.1,5876.6l-8-18.2l-8,18.2 H747.1z M740,5850h-4.8l7.2-6.9h6.5L740,5850z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M760.8,5885.8l2-4.1c2.8,2.5,7.5,4.3,12.2,4.3c6.4,0,9.2-2.5,9.2-5.7c0-9.1-22.5-3.3-22.5-17.1 c0-5.7,4.5-10.6,14.2-10.6c4.3,0,8.9,1.2,11.9,3.3l-1.7,4.2c-3.2-2.1-6.9-3-10.2-3c-6.3,0-9,2.6-9,5.9c0,9.1,22.5,3.4,22.5,17 c0,5.7-4.6,10.5-14.4,10.5C769.3,5890.5,763.7,5888.6,760.8,5885.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.2,5853v37.1h-5.3v-16.5h-21.3v16.5h-5.3V5853h5.3v16h21.3v-16H843.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M881.3,5885.5v4.6h-26.9V5853h26.2v4.6h-20.9v11.4h18.6v4.5h-18.6v12H881.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M914.7,5890.1l-8-11.4c-0.7,0.1-1.5,0.1-2.3,0.1h-9.2v11.3h-5.3V5853h14.5c9.6,0,15.5,4.9,15.5,12.9 c0,5.7-3,9.9-8.2,11.7l8.8,12.5H914.7z M914.5,5865.9c0-5.3-3.6-8.3-10.3-8.3h-9v16.7h9C911,5874.3,914.5,5871.2,914.5,5865.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M953.2,5890.1l-8-11.4c-0.7,0.1-1.5,0.1-2.3,0.1h-9.2v11.3h-5.3V5853h14.5c9.6,0,15.5,4.9,15.5,12.9 c0,5.7-3,9.9-8.2,11.7l8.8,12.5H953.2z M953,5865.9c0-5.3-3.6-8.3-10.3-8.3h-9v16.7h9C949.5,5874.3,953,5871.2,953,5865.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M990.6,5880.8h-19.7l-4.1,9.3h-5.5l16.8-37.1h5.2l16.9,37.1h-5.6L990.6,5880.8z M988.7,5876.6l-8-18.2 l-8,18.2H988.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1040.1,5890.1l-0.1-27l-13.4,22.5h-2.4l-13.4-22.4v26.9h-5.1V5853h4.3l15.5,26.1l15.3-26.1h4.3l0.1,37.1 H1040.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1056.3,5853h5.3v37.1h-5.3V5853z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.7,5885.5v4.6h-26.9V5853h26.2v4.6h-20.9v11.4h18.6v4.5h-18.6v12H1099.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140.2,5853v37.1h-4.3l-22.3-27.7v27.7h-5.3V5853h4.3l22.3,27.7V5853H1140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1158.7,5857.6H1146v-4.6h30.7v4.6h-12.7v32.5h-5.2V5857.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1204.2,5880.8h-19.7l-4.1,9.3h-5.5l16.8-37.1h5.2l16.9,37.1h-5.6L1204.2,5880.8z M1202.3,5876.6l-8-18.2 l-8,18.2H1202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1216,5885.8l2-4.1c2.8,2.5,7.5,4.3,12.2,4.3c6.4,0,9.2-2.5,9.2-5.7c0-9.1-22.5-3.3-22.5-17.1 c0-5.7,4.5-10.6,14.2-10.6c4.3,0,8.9,1.2,11.9,3.3l-1.7,4.2c-3.2-2.1-6.9-3-10.2-3c-6.3,0-9,2.6-9,5.9c0,9.1,22.5,3.4,22.5,17 c0,5.7-4.6,10.5-14.4,10.5C1224.5,5890.5,1218.9,5888.6,1216,5885.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursoMasherramientas);
export default __webpack_public_path__ + "static/media/recurso_masherramientas.04e8d229ab35fa31321841f3179aadac.svg";
export { ForwardRef as ReactComponent };